import React, { useContext, useState } from "react";
import { TableContext } from "../../index";
import SearchInputV2 from "../../view/SearchInputV2";
import ValidationResultTableSearchSection from "../../rules/ValidationResultTableSearchSection";
import { debug, notImplemented } from "../../utils";
import { connect } from "react-redux";
import { Download } from "lucide-react";

function DeviceDetailsTableHeader() {
    const { config, setConfig } = useContext(TableContext);
    const [searchTerm, setSearchTerm] = useState('');

    const onSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        setConfig({ ...config, searchTerm: value });
    };

    return (
        <>
            <div className="oct_analysis-header-v2">
                <div className="oct_analysis-title-section">
                    <h2>Configuration Changes</h2>
                </div>
            </div>

            <div className="oct_filter-section-v2">
                                <div className="row mb-3 align-items-end">
                    <div className="col d-flex justify-content-end">
                        <button className="oct_btn-export-v2" onClick={() => notImplemented()}>
                            <Download className="oct_icon" />
                            Export Data
                        </button>
                    </div>
                </div>
                <div className="row mb-3 align-items-end">
                    <div className="col">
                        <ValidationResultTableSearchSection device={false} />
                    </div>
                </div>


                <div className="row mb-3 align-items-end">
                    <div className="col">
                        <SearchInputV2
                            value={searchTerm}
                            onChange={onSearchChange}
                            placeholder="Search by rule name, user, or group..."
                            className="m-0"
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

function mapStateToProps(state) {
    debug("DeviceDetailsTableHeader mapStateToProps", state);
    return state;
}

export default connect(mapStateToProps)(DeviceDetailsTableHeader);
